<template>
    <div v-if="isLoaded && isHaveItem">
        <Carousel class="dashboard-home" :class="[{'dashboard-mass': theme == 'mass'}, {'dashboard-prestige': theme == 'prestige'}]"
            :responsive="responsiveConfig"
            :lazyLoad="true"
            :loop="true"
            :autoplay="true"
            :autoplayTimeout="5000"
            :nav="false">
            <div class="dashboard-item"
                v-for="(dashboard, k) in rotateList"
                :key="k"
                @click="clickDashboard(dashboard)">
                <img :src="dashboard.imageUrl" >
            </div>
        </Carousel>
    </div>
</template>
<script>
import Vue from 'vue';
//plugin
import Carousel from 'vue-owl-carousel';
//helper
import Account from "@/helper/AccountHelper.js";
import Locale from "@/helper/locale/locale.js";
//mixin
import ErrorApiMixin from "@/mixin/ErrorApiMixin.js";
//core
import { SubDashboardConfigBuilder } from '@/core/Campaign/model/DashboardConfigModel.js';
import BzbsDashboard from '@/core/Campaign/service/BzbsDashboard.js';
// helper
import { TrackingService } from "@/helper/TrackingHelper.js";

export default {
    name: 'HomeDashboard',

    mixins: [ErrorApiMixin],
    components: {
        Carousel
    },
    computed: {
        tier: function () {
            return this.$store.state.tier;
        },
        theme: function () {
            return this.$store.state.theme;
        },
        isAmbassador: function () {
            return this.$store.state.isAmbassador;
        }
    },
    props: {
        modalController: Object
    },
    data: function () {
        return {
            isHaveItem: false,
            isLoaded: false,
            rotateList: [],
            responsiveConfig: {
                0: { items: 1 }
            },
            trackingService: new TrackingService(this),
        }
    },
    created: function () {
        this.initialDashboard();
        this.errorHandler.setAlertModal(this.modalController.alertModal);
        this.errorHandler.setNoInternetModal(this.modalController.noInternetModal);
    },
    methods: {
        //callback
        apiLoaded: function () {
            this.$emit('apiLoaded', { 'api': 'dashboard' });
        },
        //click
        clickDashboard: function (dashboard) {
            var tracking_label = dashboard.strGA ? dashboard.strGA : ''
            var trackingEventCategory = 'homepage_list'
            var eventName = 'click_dashboard_event'
            if(tracking_label) {
                this.trackingService.event(trackingEventCategory, eventName, tracking_label, null)
            }

            if (!dashboard) return;

            switch (dashboard.type) {
                case 'campaign':
                    if (dashboard.id)
                        this.$router.push(`/reward/detail/${dashboard.id}`);
                    break;
                case 'cat':
                    if (dashboard.cat) {
                        if (dashboard.line1) {
                            this.$router.push(`/reward/${dashboard.line1}/sub/${dashboard.cat}`);
                        } else {
                            this.$router.push(`/reward/${dashboard.cat}`);
                        }
                    }
                    break;
                case 'link':
                    if (dashboard.url)
                        window.location.href = dashboard.url;

                    break;
            }

        },
        //method
        initialDashboard: function () {
            //initial dashboard name.
            var dashboardName;
            if (this.tier == 'm') {
                dashboardName = this.isAmbassador
                    ? Vue.bzbsConfig.dashboardConfig.mass_am
                    : Vue.bzbsConfig.dashboardConfig.mass;
            } else {
                dashboardName = this.isAmbassador
                    ? Vue.bzbsConfig.dashboardConfig.prestige_am
                    : Vue.bzbsConfig.dashboardConfig.prestige;
            }

            //initial dashboard config.
            var dashboardConfigBuilder = new SubDashboardConfigBuilder();
            var dashboardConfigModel = dashboardConfigBuilder
                                            .setLocale(Locale.getLocaleCode())
                                            .setDashboardName(dashboardName)
                                            .create();

            var token = Account.getToken();
            BzbsDashboard.apiGetSubDashboard(token, dashboardConfigModel.getParams(), dashboardConfigModel.strDashboardName)
                .then(res => {
                    var rotate = res.filter(dashboard => {
                        return (dashboard.type == 'campaign_rotate');
                    });

                    this.rotateList = [...rotate[0].subCampaignDetails];

                    this.isHaveItem = this.rotateList.length > 0
                                        ? true
                                        : false;
                    this.isLoaded = true;
                    this.apiLoaded();
                }).catch(err => {
                    this.isLoaded = true;
                    this.isHaveItem = false;
                    this.errorApi(err, this.errorHandler);
                });
        }
    }
}
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";

.dashboard-item {
    @include baseRatioImg(50%);
    width: 100%;
}
</style>
<style lang="scss">
@import "@/style/base/base.scss";
@import "@/style/custom/owl.scss";
.dashboard-home {
    &.dashboard-mass {
        @include owl(rgba($mass_theme_color, 0.4), $mass_theme_color);
    }

    &.dashboard-prestige {
        @include owl(rgba($prestige_theme_color, 0.4), $prestige_theme_color);
    }
}
</style>
